import * as React from 'react';

import { css } from '@emotion/core';
import {fontSize} from "../../Styles/text";

import mq from '../../Styles/breakpoints';

const callout = css`
  padding: 50px;
  border: 1px solid #fff;
  color: #ffffff;
  margin: 0.9375rem 0;
`;

const header = css`
  color: #fff;
  ${fontSize(3)}; 
`;

export default class ScheduleError extends React.Component<any> {
  render() {
    return <div>
      <div css={callout}>
        <h4 css={header} className="headline">{ this.props.message }</h4> 
        <a href="/schedule" class="call-to-action-btn">See today&rsquo;s schedule</a>
      </div>
    </div>;
  }
}